const textChange = {
  textFormat: document.querySelectorAll(
    ".jsTextHtml"
  ) as NodeListOf<HTMLElement>,
  wordFormat: document.querySelectorAll(
    ".jsWordFormat"
  ) as NodeListOf<HTMLElement>,

  init() {
    this.textChange();
    // this.wordFormatDots();
  },
  wordFormatDots() {
    this.wordFormat.forEach((item) => {      
      const length = item.dataset.length as string;
      const text = item.innerText
      if (text.length >= +length) {
        item.innerText = text.slice(0, +length) + "...";
      }
    });
  },
  textChange() {
    this.textFormat.forEach((item) => {
      const text = item.dataset.text as string;
      item.innerHTML = text;
    });
  },
};

export default textChange;
